/**
 * Returns a human-readable relative time string.
 * Updates: "just now" → "1m ago" → "5m ago" → "1h ago" → "3h ago" → "Mar 30"
 */
export function relativeTime(date: Date): string {
  const now = Date.now();
  const diff = now - date.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (seconds < 60) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;

  // Beyond 24h, show short date
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
